export const COMMON_TIMEZONES = [
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Phoenix",
  "Europe/London",
  "Europe/Paris",
  "Europe/Berlin",
  "Asia/Tokyo",
  "Asia/Shanghai",
  "Australia/Sydney",
  "Pacific/Auckland",
];

export const ALL_HOURS = [
  "00:00", "01:00", "02:00", "03:00", "04:00", "05:00",
  "06:00", "07:00", "08:00", "09:00", "10:00", "11:00",
  "12:00", "13:00", "14:00", "15:00", "16:00", "17:00",
  "18:00", "19:00", "20:00", "21:00", "22:00", "23:00",
];

export const DAYS_OF_WEEK = [
  "monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday",
];

export function getCurrentHourInTz(tz: string): number {
  try {
    return Number(
      new Intl.DateTimeFormat("en-US", {
        timeZone: tz,
        hour: "numeric",
        hour12: false,
      }).format(new Date())
    );
  } catch {
    return new Date().getHours();
  }
}

export function getLocalDateString(date: Date, tz: string): string {
  try {
    return new Intl.DateTimeFormat("en-CA", { timeZone: tz }).format(date);
  } catch {
    return new Intl.DateTimeFormat("en-CA").format(date);
  }
}

export function isSameDateInTz(a: Date, b: Date, tz: string): boolean {
  return getLocalDateString(a, tz) === getLocalDateString(b, tz);
}

export function getBrowserTimezone(): string {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  // Europe/Kiev was renamed to Europe/Kyiv in tzdata 2022b; older browsers return the legacy name
  if (tz === "Europe/Kiev") return "Europe/Kyiv";
  return tz;
}

export function getTimezoneOptions(currentTimezone: string): string[] {
  const all: string[] = (() => {
    try {
      return [...Intl.supportedValuesOf("timeZone")].sort();
    } catch {
      return [...COMMON_TIMEZONES].sort();
    }
  })();

  if (all.includes(currentTimezone)) {
    return [currentTimezone, ...all.filter((tz) => tz !== currentTimezone)];
  }
  return all;
}
